import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Store, select } from '@ngrx/store';
import { CoalService } from 'app/services/coal.service';
import { MostrarExcepcion, MostrarSpinner, OcultarSpinner } from 'app/store/actions/utils.action';
import { AppState, selectUtilsState } from 'app/store/app.states';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { CatPais, TipoUbicacion } from 'app/shared/enum.shared';
import { SharedService } from 'app/shared.service';

export interface IParteTransporteFig {
    Index: string;
    Id: number;
    IdTransporte: number;
    title: string;
}

@Component({
    selector: 'app-tipos-figura',
    templateUrl: './tipos-figura.component.html',
    styleUrls: ['./tipos-figura.component.scss']
})
export class TiposFiguraComponent implements OnInit {
    @Output() FormFigurasEventEmiter = new EventEmitter<any>();

    @Input() idOperacion: any;
    @Input() idFiguras: any;
    @Input() title: any;

    idEmpresa: number = 0;
    empresaData: any;
    catFiguras: any[] = [];
    autoTransportes: any[] = [];
    isParteTransportes: boolean = false;
    tipoFigurasList: any[] = [];
    paisesGlobal: any[] = [];
    paises: any[] = [];

    rfcPattern: RegExp = new RegExp('^[A-Z,Ñ,&]{3,4}[0-9]{2}[0-1][0-9][0-3][0-9][A-Z,0-9]?[A-Z,0-9]?[0-9,A-Z]?$');

    tipo: any[] = [];

    countContenedor: IParteTransporteFig[] = [];
    lstContenedor: IParteTransporteFig[] = [];
    catContenedores: any[] = [];
    defualtContenedor: IParteTransporteFig = { Index: `ContenedorParteT${this.countContenedor.length + 1}`, Id: 0, IdTransporte: 0, title: '' };
    formContenedores: any[] = [];

    //FORM FIGURA
    FormFiguras = new FormGroup({
        figura: new FormControl(0),
        nombre: new FormControl(null),
        tipoFigura: new FormControl(null, [Validators.required, Validators.min(1)]),
        RFCFigura: new FormControl(null, [Validators.pattern(this.rfcPattern)]),
        residenciaFiscalFigura: new FormControl(''),
        numRegIdTribFigura: new FormControl(''),
        numLicencia: new FormControl('')
    });

    //FORM DIRECCION
    codigoPostal;
    ubicaciones: any[] = [];
    tubicaciones: any;

    clickAdress: number = 0;
    showAdress: boolean = false;
    estados: any[] = [];
    municipios: any[] = [];
    localidades: any[] = [];
    colonias: any[] = [];
    curDireccion: any[] = [];
    cp: number;
    cpPattern = /^[0-9]{5}/;

    FormDomicilio = new FormGroup({
        idPais: new FormControl(CatPais.Mexico, [Validators.required]),
        cPostal: new FormControl(null, [Validators.pattern(this.cpPattern)]),
        idEstado: new FormControl(null),
        idMunicipio: new FormControl(null),
        idLocalidad: new FormControl(null),
        idColonia: new FormControl(null),
        estado: new FormControl(null),
        municipio: new FormControl(null),
        localidad: new FormControl(null),
        colonia: new FormControl(null),
        calle: new FormControl(null),
        numExt: new FormControl(null),
        numInt: new FormControl(null),
        referencia: new FormControl(null),
    });

    partesTransportes: any[] = [];

    filteredPais: Observable<any>;

    idTipoFigura: number = 0;
    removeDisabledTPartes: boolean = true;
    constructor(
        private _snackBar: MatSnackBar,
        private store: Store<AppState>,
        private srvcoal: CoalService,
        private sharedService: SharedService,
    ) {

    }

    async ngOnInit(): Promise<void> {
        this.getDirPais();
        this.empresaData = await this.getEmpresa();
        this.idEmpresa = this.empresaData.id || 0;
        const ls = await this.getFiguras();
        this.getTipoFigura();

        this.getPartesTransporte();

        let mexico = this.paises.find(x => x.id == CatPais.Mexico);
        this.paisesInput.setValue(mexico || null);
        this.filteredPais = this.paisesInput.valueChanges.pipe(
            startWith(''),
            map(value => {
                const name = typeof value === 'string' ? value : '';
                return name ? this._filterPais(name as string) : this.paises.slice();
            }),
        );

        this.sharedService.parteTrasporteForm$.subscribe(valores => {
            const index = this.lstContenedor.findIndex(item => item && item.Index === valores.Index && item.IdTransporte === valores.IdTransporte);
            if (index === -1) {
                if (valores) this.lstContenedor.push(valores);
            } else {
                if (valores) this.lstContenedor[index] = valores;
            }
        });

        this.senddata();
    }

    private _filterPais(value: string): any {
        const filterValue = value.toLowerCase();
        return this.paises.filter(option => option.attributes.idPais.toLowerCase().includes(filterValue) || option.attributes.nombre.toLowerCase().includes(filterValue));
    }

    displayFuncionPais(pais: any): string {
        if (pais?.attributes)
            return '' + pais?.attributes.idPais + '-' + pais?.attributes?.nombre;
        else
            return '';
    };

    // convenience getter for easy access to form fields
    get f() { return this.FormFiguras.controls; }
    get paisesInput() { return this.FormFiguras.get('residenciaFiscalFigura'); }

    getEmpresa(): Promise<any> {
        return new Promise<any>(resolve => {
            this.store.pipe(select(selectUtilsState)).subscribe((info: any) => {
                let empresa = info?.empresaSeleccionada || null;
                resolve(empresa);
            });
        });
    }
    //Buscando y asignando valores a los formularios
    changeTipoFigura(value) {
        console.log("🚀 ~ TiposFiguraComponent ~ changeTipoFigura ~ value:", value)

        this.idTipoFigura = value || 0;
        if (this.idTipoFigura > 0) {
            //Bucando datos Figura / Direccion / Partes...
            this.getTipoFiguraSeleccionado(this.idTipoFigura);

        } else {
            //impiando formulario
            this.FormFiguras.reset();
            this.FormDomicilio.reset();
            this.f['figura'].setValue(0);
            this.lstContenedor = [];
            this.countContenedor = [];
        }

    }

    selectionTipoFigura(value) {
        //console.log("🚀 ~ TiposFiguraComponent ~ changeTipoFigura ~ value:", value);
        let idPT = Number(value || 0);
        let isParteT = this.tipoFigurasList.find(x => x.id == idPT);
        this.countContenedor = [];
        this.isParteTransportes = Boolean(isParteT?.attributes?.AplicaPartesTransporte || false);
    }

    senddata() {
        this.FormFiguras.statusChanges.subscribe(status => {
            if (this.FormFiguras.valid) {
                let data = { idFigura: this.idFiguras, title: this.title }
                this.FormFigurasEventEmiter.emit(data);
            }
        });
    }

    textUppercase(ctrl: string, event: any) {
        if (ctrl && event) {
            this.FormFiguras.get(ctrl)?.setValue(event.target.value?.toUpperCase());
        }
    }

    async getFiguras(): Promise<boolean> {
        return new Promise<boolean>(resolve => {
            this.store.dispatch(MostrarSpinner());
            this.srvcoal.getService(`ope-empresas?filters[id]=${this.idEmpresa}&populate[fac_porte_figuras][populate]=*`).subscribe(
                (res: any) => {
                    this.store.dispatch(OcultarSpinner());
                    if (res.err) {
                        this.store.dispatch(MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 }));
                    } else if (res.excepcion) {
                        this.store.dispatch(MostrarExcepcion({ pila: res.excepcion, tipoExcepcion: 3, }));
                    } else {
                        this.catFiguras = res.data[0]?.attributes?.fac_porte_figuras?.data || [];
                    }
                    resolve(true);
                },
                (error: any) => {
                    this.store.dispatch(OcultarSpinner());
                    this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }));
                    resolve(false);
                });
        });
    }

    getTipoFiguraSeleccionado(idFig: number = 0) {
        //this.countContenedor = [];
        this.store.dispatch(MostrarSpinner());
        this.srvcoal.getService(`fac-porte-figuras/${idFig}?populate=cat_tipo_figura,residenciaFiscalFigura,dir_codigo_postal,dir_pai,dir_estado,dir_municipio,dir_asentamiento,fac_porte_figura_partes.cat_partes_transporte`).subscribe(
            (res: any) => {
                //console.log("🚀 ~ TiposFiguraComponent ~ getTipoFiguraSeleccionado ~ res:", res)
                this.store.dispatch(OcultarSpinner());
                if (res.err) {
                    this.store.dispatch(MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 }));
                } else if (res.excepcion) {
                    this.store.dispatch(MostrarExcepcion({ pila: res.excepcion, tipoExcepcion: 3, }));
                } else {

                    let model = res?.data || {};
                    //Set Model
                    if (model?.id) {

                        let cat_tipo_figura = model?.attributes?.cat_tipo_figura || {};
                        let figura = cat_tipo_figura?.data?.id || null;

                        let residenciaFiscalFigura = model?.attributes?.residenciaFiscalFigura || {};
                        let idResidenciaFiscal = residenciaFiscalFigura?.data?.id || null;

                        let selPais: any;
                        if (idResidenciaFiscal)
                            selPais = this.paises?.find(x => x.id == idResidenciaFiscal);
                        /*
                        let dir_codigo_postal = model?.attributes?.dir_codigo_postal || {};
                        let idCodigoPostal = dir_codigo_postal?.data || {};

                       
                        */
                        let dir_pais = model?.attributes?.dir_pai || {};
                        let idDirPais = dir_pais?.data?.id || null;
                        //ESTADOS
                        if (idDirPais) {
                            this.SelEstados(idDirPais);
                        } else {
                            this.estados = [];
                            this.FormDomicilio.controls.idEstado.setValue(null);
                        }
                        //MUNICIPIOS  
                        let dir_estado = model?.attributes?.dir_estado || {};
                        let idEstado = dir_estado?.data?.id || null;
                        if (idEstado) {
                            this.selMunicipios(idEstado);
                            //this.FormDomicilio.controls.idEstado.setValue(idEstado);
                        } else {
                            this.municipios = [];
                            this.FormDomicilio.controls.idMunicipio.setValue(null);
                        }
                        //LOCALIDADES
                        let dir_municipio = model?.attributes?.dir_municipio || {};
                        let idMunicipio = dir_municipio?.data?.id || null;
                        if (idMunicipio) {
                            this.selLocalidades(idMunicipio);
                            //this.FormDomicilio.controls.idMunicipio.setValue(mpio);
                        } else {
                            this.localidades = [];
                            this.FormDomicilio.controls.idLocalidad.setValue(null);
                        }

                        //COLONIAS
                        this.colonias = [];
                        let dir_asentamiento = model?.attributes?.dir_asentamiento || {};
                        let idLocalidad = dir_asentamiento?.data?.id || null;

                        //Set form Figuras 
                        this.FormFiguras.patchValue({
                            tipoFigura: figura,
                            nombre: model?.attributes?.nombre || null,
                            RFCFigura: model?.attributes?.rfcFigura || null,
                            residenciaFiscalFigura: selPais || null,
                            numRegIdTribFigura: model?.attributes?.NumRegIdTribFigura || null,
                            numLicencia: model?.attributes?.numLicencia || null
                        });

                        //Set forma Domicilio
                        if (model?.attributes?.codigoPostal) {
                            this.showAdress = true;
                            this.FormDomicilio.patchValue({
                                idPais: idDirPais,
                                cPostal: model?.attributes?.codigoPostal,
                                idEstado: idEstado,
                                idMunicipio: idMunicipio,
                                idLocalidad: idLocalidad,
                                idColonia: null,
                                estado: model?.attributes?.estado || null,
                                municipio: model?.attributes?.municipio || null,
                                localidad: model?.attributes?.localidad || null,
                                colonia: model?.attributes?.colonia || null,
                                calle: model?.attributes?.calle || null,
                                numExt: model?.attributes?.numeroExterior || null,
                                numInt: model?.attributes?.numeroInterior || null,
                                referencia: model?.attributes?.referencia || null,
                            });

                        } else {
                            this.showAdress = false;
                            this.FormDomicilio.reset();
                        }

                        //Set fac_porte_figura_partes
                        //Existe parte transporte
                        const myContenedores: any[] = model?.attributes?.fac_porte_figura_partes?.data || [];
                        this.isParteTransportes = (myContenedores.length > 0);
                        //console.log("🚀 ~ MaritimoComponent ~ myContenedores:", myContenedores)
                        for (const { id, attributes } of myContenedores) {
                            let idTransporte = attributes?.cat_partes_transporte?.data?.id || 0
                            if (idTransporte > 0) {
                                let element: IParteTransporteFig = { Index: '', Id: id, IdTransporte: idTransporte, title: `Partes Transporte ${this.countContenedor.length + 1}` };
                                this.addTPartes(element);
                            }
                        }
                    }
                }
            },
            (error: any) => {
                this.store.dispatch(OcultarSpinner());
                this.store.dispatch(
                    MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
                );

            }
        );
    }

    changePais(value: number) {
        //console.log("🚀 ~ TiposFiguraComponent ~ changePais ~ value:", value)
        //Residencia fiscal
        this.validarRfigura(value);
    }

    validarRfigura(idPaisSel: number) {
        //let paisSelected: any = this.FormFiguras.controls.residenciaFiscalFigura.value || {};
        //let idPaisSel = paisSelected?.id || null;
        //Es Mexico
        if (idPaisSel == CatPais.Mexico) {
            this.FormFiguras.get('RFCFigura').setValidators([Validators.pattern(this.rfcPattern)]);
            this.FormFiguras.get('RFCFigura').updateValueAndValidity();
            this.FormFiguras.controls['numRegIdTribFigura'].disable();
        } else {
            this.FormFiguras.controls['numRegIdTribFigura'].enable();
            //this.FormFiguras.get('RFCFigura').clearValidators();
            this.FormFiguras.get('RFCFigura').setValidators([Validators.pattern(this.rfcPattern)]);
            this.FormFiguras.get('RFCFigura').updateValueAndValidity();
        }
    }

    validaInputRFC() {

        if (this.FormFiguras.controls.RFCFigura.value) {

            this.FormFiguras.controls['numRegIdTribFigura'].disable();
            this.FormFiguras.controls.numRegIdTribFigura.setValue('');
        } else {
            this.FormFiguras.controls['numRegIdTribFigura'].enable();
        }
    }


    getTipoFigura() {
        this.srvcoal.getService('cat-tipo-figuras?populate=*').subscribe(
            (res: any) => {
                //console.log("🚀 ~ TiposFiguraComponent ~ getTipoFigura ~ res:", res)

                this.store.dispatch(OcultarSpinner());
                if (res.err) {
                    this.store.dispatch(
                        MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 })
                    );
                } else if (res.excepcion) {
                    this.store.dispatch(
                        MostrarExcepcion({ pila: res.excepcion, tipoExcepcion: 3, })
                    );
                } else {
                    this.tipoFigurasList = res.data || [];
                    //this.paises = res.recordsets[1];
                }
            },
            (error: any) => {
                this.store.dispatch(OcultarSpinner());
                this.store.dispatch(
                    MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
                );

            }
        );
    }

    getDirPais() {
        this.srvcoal.getService('dir-paises?populate=*&pagination[start]=0&pagination[limit]=300').subscribe(
            (res: any) => {
                //console.log("🚀 ~ TiposFiguraComponent ~ getDirPais ~ res:", res)

                this.store.dispatch(OcultarSpinner());
                if (res.err) {
                    this.store.dispatch(
                        MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 })
                    );
                } else if (res.excepcion) {
                    this.store.dispatch(
                        MostrarExcepcion({ pila: res.excepcion, tipoExcepcion: 3, })
                    );
                } else {
                    // El objeto que quieres agregar
                    let nuevoElemento = { id: 0, attributes: { idPais: '', nombre: 'Sin selección' } };

                    this.paisesGlobal = res.data || [];
                    this.paises = res.data || [];
                    this.paises.unshift(nuevoElemento);

                }
            },
            (error: any) => {
                this.store.dispatch(OcultarSpinner());
                this.store.dispatch(
                    MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
                );

            }
        );
    }


    addAddress() {
        this.clickAdress++;
        if (this.clickAdress % 2) {
            this.showAdress = true;
        } else {
            this.showAdress = false;
        }
    }

    SelEstados(value) {
        //console.log("🚀 ~ TiposFiguraComponent ~ SelEstados ~ value:", value)
        //return new Promise<boolean>(resolve => {
        this.store.dispatch(MostrarSpinner());
        this.srvcoal.getService(`dir-estados?filters[dir_pai]=${value}`).subscribe(
            (res: any) => {
                this.store.dispatch(OcultarSpinner());
                this.estados = res?.data || [];
                //resolve(true);
            }, (error: any) => {
                this.store.dispatch(OcultarSpinner());
                //resolve(false);
            });
        // });
    }
    selMunicipios(value) {
        //console.log("🚀 ~ TiposFiguraComponent ~ selMunicipios ~ value:", value)

        this.store.dispatch(MostrarSpinner());
        this.srvcoal.getService(`dir-municipios?filters[dir_estado]=${value}&pagination[start]=0&pagination[limit]=54000`)
            .subscribe((res: any) => {
                this.store.dispatch(OcultarSpinner());
                this.municipios = res.data;
            }, (error: any) => {
                this.store.dispatch(OcultarSpinner());
                this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }));
            })

    }

    selLocalidades(value) {
        //console.log("🚀 ~ TiposFiguraComponent ~ selLocalidades ~ value:", value)
        //let idPais = this.FormDomicilio.controls.pais.value;
        //let entidad = this.FormDomicilio.controls.idEstado.value;
        //let municipio = value;
        this.store.dispatch(MostrarSpinner());

        this.srvcoal.getService(`dir-asentamientos?filters[dir_municipio]=${value}&pagination[start]=0&pagination[limit]=54000`)
            .subscribe((res: any) => {
                this.store.dispatch(OcultarSpinner());
                this.localidades = res.data || [];
            }, (error: any) => {
                this.store.dispatch(OcultarSpinner());

            })

    }

    selColonias(value) {
        //console.log("🚀 ~ TiposFiguraComponent ~ selColonias ~ value:", value)
        this.colonias = [];

        //let idPais = this.FormDomicilio.controls.pais.value;
        //let entidad = this.FormDomicilio.controls.idEstado.value;
        //let municipio = this.FormDomicilio.controls.idMunicipio.value;
        let colonia = value;
        /*
        this.store.dispatch(MostrarSpinner());
        //this.srvcoal.getService(`catalogo/GetCP?idPais=${idPais}&idEstado=${entidad}&idMunicipio=${municipio}&idAsentamiento=${colonia}`)
        this.srvcoal.getService(`dir-asentamientos?filters[dir_municipio]=${municipio}&pagination[start]=0&pagination[limit]=54000`)
            .subscribe(
                (res: any) => {
                    if (res.err) {
                        this.store.dispatch(
                            MostrarExcepcion({
                                pila: res.error,
                                tipoExcepcion: 4,
                            })
                        );
                    } else if (res.excepcion) {
                        this.store.dispatch(
                            MostrarExcepcion({
                                pila: res.excepcion,
                                tipoExcepcion: 3,
                            })
                        );
                    } else {
                        this.codigoPostal = res.recordsets[0][0].CP;
                        //console.log(res.recordsets[0][0].CP)
                        this.FormDomicilio.controls['cPostal'].setValue(this.codigoPostal);
                        this.store.dispatch(OcultarSpinner());
                        // this.spinner = false;
                    }
                },
                (error: any) => {
                    this.store.dispatch(
                        MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
                    );
                    this.store.dispatch(OcultarSpinner());

                }
            );*/
    }

    verificaCP() {
        if (this.FormDomicilio.controls.cPostal.valid) {
            this.consultarCP();
        }
    }

    consultarCP() {
        let CP = this.FormDomicilio.value.cPostal || null;
        if (CP == null)
            return this._snackBar.open("Ingrese un CP", 'Ok', { duration: 8000 });

        if (this.FormDomicilio.controls.cPostal.valid === false) {
            this._snackBar.open('Verifique el código postal', 'ok', {
                duration: 3000,
            });
        } else {
            this.store.dispatch(MostrarSpinner());
            //this.spinner = true;
            this.srvcoal.getService(`dir-codigos-postales?filters[cp]=${CP}&populate[0]=dir_asentamiento.dir_municipio.dir_estado.dir_pai`)
                .subscribe(async (res: any) => {
                    //console.log("🚀 ~ TiposFiguraComponent ~ consultarCP ~ res:", res)

                    this.store.dispatch(OcultarSpinner());
                    if (res.data[0]?.id) {
                        this.cp = res.data[0]?.id;
                        //ESTADOS
                        let idP = res.data[0]?.attributes?.dir_asentamiento?.data?.attributes?.dir_municipio?.data?.attributes?.dir_estado?.data?.attributes?.dir_pai?.data?.id || 0;

                        if (idP > 0) {
                            this.SelEstados(idP);
                            // this.FormDomicilio.controls.idPais.setValue(idP);
                        } else {
                            //this.FormDomicilio.controls.idPais.setValue(null);
                            this.estados = [];
                            this.FormDomicilio.controls.idEstado.setValue(null);
                        }
                        //MUNICIPIOS  
                        let edo = res.data[0]?.attributes?.dir_asentamiento?.data?.attributes?.dir_municipio?.data?.attributes?.dir_estado?.data?.id || 0;
                        if (edo > 0) {
                            this.selMunicipios(edo);
                            this.FormDomicilio.controls.idEstado.setValue(edo);
                        } else {
                            this.municipios = [];
                            this.FormDomicilio.controls.idMunicipio.setValue(null);
                        }
                        //LOCALIDADES
                        let mpio = res.data[0]?.attributes?.dir_asentamiento?.data?.attributes?.dir_municipio?.data?.id || 0;
                        if (mpio > 0) {
                            this.selLocalidades(mpio);
                            this.FormDomicilio.controls.idMunicipio.setValue(mpio);
                        } else {
                            this.localidades = [];
                            this.FormDomicilio.controls.idLocalidad.setValue(null);
                        }

                        //COLONIAS
                        this.colonias = [];

                        // let loc = res.data[0]?.attributes?.dir_asentamiento?.data?.id || 0;
                        // if (loc > 0) {
                        //     this.FormDomicilio.controls.idLocalidad.setValue(loc);
                        // } else {

                        // }
                        // this.FormDomicilio.controls.pais.disable();
                        //this.FormDomicilio.controls.estado.disable();
                        //this.FormDomicilio.controls.municipio.disable();
                        //this.FormDomicilio.controls.localidad.disable();

                    } else {
                        this._snackBar.open(
                            'No se encontraron coincidencias con ese CP. Favor de llenar los datos de forma manual.',
                            'OK',
                            { duration: 9000 }
                        )

                        this.estados = [];
                        this.municipios = [];
                        this.localidades = [];
                        this.colonias = [];

                    }
                }, (error: any) => {
                    this.store.dispatch(OcultarSpinner());
                })

        }
    }


    async deleteTipoFigura() {

        let idTypeFig = this.FormFiguras.value.figura || 0;
        //Existe valor seleccionado
        if (idTypeFig > 0) {

            //Eliminacion Logica de Contenedores
            if (this.lstContenedor.length > 0) {
                for await (const item of this.lstContenedor) {
                    if (item.Id > 0) {//draft
                        const res = await this.logicalDeleteContenedor(item.Id);
                    }
                }
            }

            //Eliminacion Logica de Tipo Figura seleccionado
            const result = await this.logicalDeleteTipoFigura(idTypeFig);

            //Actualizando relacion en OpeEmpresa
            this.catFiguras.splice(
                this.catFiguras.find((item, index) => {
                    if (item.id == idTypeFig)
                        return index
                }), 1
            );

            //Update ope OpeEmpresa     
            const resultEmpresa = await this.updateEmpresaPorteFiguras();
            //Refresh...
            const ls = await this.getFiguras();

            //limpiar formulario
            this.FormFiguras.reset();
            this.FormDomicilio.reset();
            this.f['figura'].setValue(0);
            this.lstContenedor = [];
            this.countContenedor = [];

        }

    }

    async saveOrUpdateTipoFigura(): Promise<boolean> {

        return new Promise<boolean>(async (resolve) => {

            if (this.FormFiguras.valid) {
                //Forms contenedor parte trans porte            
                this.formContenedores = [];
                if (this.lstContenedor.length > 0) {
                    //Save Or Update Contenedores
                    for await (const item of this.lstContenedor) {
                        if (item.Id > 0) {//Update
                            const res = await this.updateContenedor(item.Id, item.IdTransporte);
                        } else { //Save
                            const res = await this.saveContenedor(item.IdTransporte);
                        }
                    }
                }

                // +++++ ADD OR UPDATE ------------
                let idFigura = this.FormFiguras.value.figura || 0;
                //Residencia fiscal
                let paisSelected: any = this.FormFiguras.value.residenciaFiscalFigura || {};
                let idPaisSel = paisSelected?.id || null;

                let data = {
                    data: {
                        nombre: this.FormFiguras.value.nombre || null,
                        cat_tipo_figura: this.FormFiguras.value.tipoFigura || null,
                        rfcFigura: this.FormFiguras.value.RFCFigura || null,
                        residenciaFiscalFigura: idPaisSel,
                        numLicencia: this.FormFiguras.value.numLicencia || null,
                        dir_pai: this.showAdress ? (this.FormDomicilio.value.idPais || null) : null,
                        dir_estado: this.showAdress ? (this.FormDomicilio.value.idEstado || null) : null,
                        dir_municipio: this.showAdress ? (this.FormDomicilio.value.idMunicipio || null) : null,
                        dir_localidad: this.showAdress ? (this.FormDomicilio.value.idLocalidad || null) : null,
                        dir_asentamiento: this.showAdress ? (this.FormDomicilio.value.idColonia || null) : null,
                        dir_codigo_postal: this.showAdress ? (this.cp || null) : null,
                        codigoPostal: this.showAdress ? (this.FormDomicilio.value.cPostal || null) : null,
                        estado: this.showAdress ? (this.FormDomicilio.value.estado || null) : null,
                        municipio: this.showAdress ? (this.FormDomicilio.value.municipio || null) : null,
                        localidad: this.showAdress ? (this.FormDomicilio.value.localidad || null) : null,
                        colonia: this.showAdress ? (this.FormDomicilio.value.colonia || null) : null,
                        numeroExterior: this.showAdress ? (this.FormDomicilio.value.numExt || null) : null,
                        numeroInterior: this.showAdress ? (this.FormDomicilio.value.numInt || null) : null,
                        calle: this.showAdress ? (this.FormDomicilio.value.calle || null) : null,
                        NumRegIdTribFigura: this.showAdress ? (this.FormFiguras.value.numRegIdTribFigura || null) : null,
                        referencia: this.showAdress ? (this.FormDomicilio.value.referencia || null) : null,
                        fac_porte_figura_partes: this.formContenedores

                    }
                }

                //++++++---------------------------
                if (idFigura > 0) {//UPDATE
                    this.store.dispatch(MostrarSpinner());
                    this.srvcoal.putService(`fac-porte-figuras/${idFigura}`, data).subscribe(async (res: any) => {
                        //console.log("🚀 ~ MaritimoComponent ~ ******* UPDATE:", res)
                        this.store.dispatch(OcultarSpinner());
                        if (res.err) {
                            this.store.dispatch(MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 }));
                        } else if (res.excepcion) {
                            this.store.dispatch(MostrarExcepcion({ pila: res.excepcion, tipoExcepcion: 3, }));
                        } else {
                            //Obtenbiendo respuesta y refrescando select...
                            let result = res?.data || { id: 0 };
                            if (result?.id > 0) {
                                let idSelected = Number(result.id || 0);
                                if (idSelected > 0) {
                                    const updempresa = await this.updateEmpresaPorteFiguras(idSelected);
                                    const ls = await this.getFiguras();
                                    this.f['figura'].setValue(idSelected);
                                }

                                this._snackBar.open("Registro Actualizado", 'Ok', { duration: 10000 });

                            } else {
                                this._snackBar.open("Ocurrió un erro al guardar información", 'Ok', { duration: 10000 });
                            }
                        }

                        resolve(true);
                    },
                        (error: any) => {
                            console.error(error);
                            resolve(false);
                        });
                } else { //ADD
                    this.store.dispatch(MostrarSpinner());
                    this.srvcoal.postService('fac-porte-figuras', data).subscribe(async (res: any) => {
                        //console.log("🚀 ~ MaritimoComponent ~ ADD ~ res:", res)
                        this.store.dispatch(OcultarSpinner());
                        if (res.err) {
                            this.store.dispatch(MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 }));
                        } else if (res.excepcion) {
                            this.store.dispatch(MostrarExcepcion({ pila: res.excepcion, tipoExcepcion: 3, }));
                        } else {
                            //Obtenbiendo respuesta y refrescando select...
                            let result = res?.data || { id: 0 };
                            if (result?.id > 0) {
                                let idSelected = Number(result.id || 0);
                                if (idSelected > 0) {
                                    const updempresa = await this.updateEmpresaPorteFiguras(idSelected);
                                    const ls = await this.getFiguras();
                                    this.f['figura'].setValue(idSelected);
                                }

                                this._snackBar.open("Registro Exitoso", 'Ok', { duration: 10000 });

                            } else {
                                this._snackBar.open("Ocurrió un erro al guardar información", 'Ok', { duration: 10000 });
                            }
                        }

                        resolve(true);
                    },
                        (error: any) => {
                            this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }));
                            this.store.dispatch(OcultarSpinner());
                            resolve(false);
                        });
                }

            } else {
                this._snackBar.open("Los campos marcados con asterisco (*) son requeridos", 'Ok', { duration: 8000 });
                resolve(false);
            }

        });
    }

    saveContenedor(idTransporte: number = 0): Promise<boolean> {
        return new Promise<boolean>(resolve => {

            let data = {
                data: {
                    cat_partes_transporte: idTransporte,
                }
            };

            this.srvcoal.postService('fac-porte-figura-partes', data).subscribe((res: any) => {
                if (res?.err) {
                    this.store.dispatch(MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 }));
                } else if (res?.excepcion) {
                    this.store.dispatch(MostrarExcepcion({ pila: res.excepcion, tipoExcepcion: 3 }));
                } else {
                    let result = res?.data || { id: 0 };
                    if (result?.id > 0) {
                        this.formContenedores.push(result.id);
                    }


                }

                resolve(true);
            },
                (error: any) => {
                    this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }));
                    resolve(false);
                });

        });

    }

    updateContenedor(id: number = 0, idTransporte: number = 0): Promise<boolean> {
        return new Promise<boolean>(resolve => {
            let data = {
                data: {
                    cat_partes_transporte: idTransporte,
                }
            };

            this.srvcoal.putService(`fac-porte-figura-partes/${id}`, data).subscribe((res: any) => {

                if (res?.err) {
                    this.store.dispatch(MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 }));
                } else if (res?.excepcion) {
                    this.store.dispatch(MostrarExcepcion({ pila: res.excepcion, tipoExcepcion: 3 }));
                } else {
                    let result = res?.data || { id: 0 };
                    if (result?.id > 0) {
                        this.formContenedores.push(result.id);

                    }
                }
                resolve(true);
            },
                (error: any) => {
                    this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }));
                    resolve(false);
                });

        });
    }

    logicalDeleteContenedor(idCont: number = 0): Promise<boolean> {
        return new Promise<boolean>(resolve => {
            let model = {
                data: { publishedAt: null }
            };
            this.srvcoal.putService(`fac-porte-figura-partes/${idCont}`, model).subscribe(async (res: any) => {
                //console.log("🚀 ~ MaritimoComponent ~ logicalDeleteContenedor:", res)
                resolve(true);
            },
                (error: any) => {
                    console.error(error);
                    resolve(false);
                });

        });
    }

    logicalDeleteTipoFigura(idTipoFig: number = 0): Promise<boolean> {
        return new Promise<boolean>(resolve => {
            let model = {
                data: { publishedAt: null }
            };
            this.srvcoal.putService(`fac-porte-figuras/${idTipoFig}`, model).subscribe((res: any) => {
                resolve(true);
            },
                (error: any) => {
                    console.error(error);
                    resolve(false);
                });

        });
    }

    updateEmpresaPorteFiguras(newId: number = 0): Promise<boolean> {
        return new Promise<boolean>(resolve => {

            const ids: number[] = this.catFiguras.map(o => o.id) || [];
            if (newId > 0)
                ids.push(newId);

            const model = {
                data: {
                    fac_porte_figuras: ids
                }
            };
            this.store.dispatch(MostrarSpinner());
            this.srvcoal.putService(`ope-empresas/${this.idEmpresa}`, model).subscribe((por: any) => {
                this.store.dispatch(OcultarSpinner());
                resolve(true);
            }, (error: any) => {
                this.store.dispatch(OcultarSpinner());
                this._snackBar.open(`Ocurrió un error al guardar datos de Figuras de Transporte  ${error?.error?.error?.message}`, "OK", { duration: 5000 });
                resolve(false);
            });
        });
    }


    //Funciones Partes Transportes
    getPartesTransporte() {
        this.srvcoal.getService('cat-partes-transportes?populate=*').subscribe(
            (res: any) => {

                this.store.dispatch(OcultarSpinner());
                if (res.err) {
                    this.store.dispatch(
                        MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 })
                    );
                } else if (res.excepcion) {
                    this.store.dispatch(
                        MostrarExcepcion({ pila: res.excepcion, tipoExcepcion: 3, })
                    );
                } else {
                    this.partesTransportes = res.data || [];

                }
            },
            (error: any) => {
                this.store.dispatch(OcultarSpinner());
                this.store.dispatch(
                    MostrarExcepcion({ pila: error, tipoExcepcion: 2 })
                );

            }
        );
    }

    //Agregar formulario dimaico Parte Transporte
    addTPartes = (contenedor: IParteTransporteFig = this.defualtContenedor) => {
        contenedor.Index = `ContenedorParteT${this.countContenedor.length + 1}`;
        this.countContenedor.push(contenedor);
        this.countContenedor.length <= 0 ? this.removeDisabledTPartes = true : this.removeDisabledTPartes = false;
    };

    //Remover formulario
    removeTPartes = () => {
        this.countContenedor.splice(-1);
        this.countContenedor.length <= 0 ? this.removeDisabledTPartes = true : this.removeDisabledTPartes = false;
    };

}
